import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager", webpackExports: ["NextImageWrapper"] */ "/app/src/components/NextImage/NextImageWrapper.tsx");
